module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('nav', {
    staticClass: "better-nav has-shadow"
  }, [_c('div', {
    staticClass: "d-flex justify-space-between flex-wrap",
    class: {
      container: _vm.container, 'nav-container': !_vm.container
    }
  }, [_c('router-link', {
    staticClass: "fw-300 color-white better-nav-item fs-6 pt-4 pb-4 pl-4",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n          ClassForward\n        ")]), _vm._v(" "), (!_vm.userAuthenticated) ? _c('div', {
    staticClass: "d-flex justify-content-end p-relative mr-4",
    class: {
      'is-active': _vm.navToggled
    }
  }, [_c('router-link', {
    staticClass: "better-nav-item is-tab",
    attrs: {
      "active-class": "is-active",
      "to": "/login",
      "exact": ""
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "better-nav-item is-tab",
    attrs: {
      "active-class": "is-active",
      "to": "/signup",
      "exact": ""
    }
  }, [_vm._v("Signup")])], 1) : _vm._e(), _vm._v(" "), (_vm.userAuthenticated) ? _c('div', {
    staticClass: "d-flex justify-content-end p-relative ml-2 grow-1",
    class: {
      'is-active': _vm.navToggled
    }
  }, [(_vm.emailConfirmed) ? _c('router-link', {
    staticClass: "better-nav-item is-tab",
    attrs: {
      "active-class": "is-active",
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Home")]) : _vm._e(), _vm._v(" "), (_vm.showColleaguesPage && _vm.emailConfirmed) ? _c('router-link', {
    staticClass: "better-nav-item is-tab",
    attrs: {
      "active-class": "is-active",
      "to": "/colleagues"
    }
  }, [_vm._v("Colleagues")]) : _vm._e(), _vm._v(" "), (_vm.emailConfirmed) ? _c('router-link', {
    staticClass: "better-nav-item is-tab",
    attrs: {
      "active-class": "is-active",
      "to": "/groups"
    }
  }, [_vm._v("Groups")]) : _vm._e(), _vm._v(" "), (_vm.hasExercisesPerm) ? _c('router-link', {
    staticClass: "better-nav-item is-tab",
    attrs: {
      "active-class": "is-active",
      "to": "/exercise"
    }
  }, [_vm._v("ALC")]) : _vm._e(), _vm._v(" "), (_vm.userIsGroupAdmin) ? _c('router-link', {
    staticClass: "better-nav-item is-tab",
    attrs: {
      "active-class": "is-active",
      "to": "/manage"
    }
  }, [_vm._v("Manage")]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "better-nav-item is-tab"
  }, [_c('NavbarNotifications')], 1), _vm._v(" "), _c('div', {
    ref: "dropdown",
    staticClass: "better-nav-item",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('img', {
    staticClass: "user-profile-image magic-button cursor-pointer",
    attrs: {
      "src": _vm.avatarURL
    }
  }), _vm._v(" "), _c('TransitionFade', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.showInviteModal),
      expression: "show && !showInviteModal"
    }],
    staticClass: "menu-dropdown flex-column min-width-150px"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/tags"
    }
  }, [_vm._v("Tags")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://support.classforward.com"
    }
  }, [_vm._v("Support")])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_vm._v("Settings")])], 1), _vm._v(" "), (_vm.canInvite) ? _c('a', {
    staticClass: "button is-outlined is-info m-2",
    on: {
      "click": function($event) {
        _vm.showInviteModal = true;
        _vm.show = false
      }
    }
  }, [_vm._v("\n                + Invite\n              ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button m-2",
    class: {
      'is-loading': _vm.loggingOut
    },
    on: {
      "click": _vm.sendLogout
    }
  }, [_vm._v("\n                Logout\n              ")])])]), _vm._v(" "), (_vm.canInvite) ? _c('InviteModal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInviteModal && _vm.canInvite),
      expression: "showInviteModal && canInvite"
    }],
    on: {
      "close": function($event) {
        _vm.showInviteModal = false
      }
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pt-4 pr-4 pb-2 d-flex direction-column flex-grow-1"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer sticky-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_vm._v("\n          © 2020 Autumnate Inc.\n        ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-76667d7c"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasePage.vue
// module id = 1067
// module chunks = 0